<template>
  <div>
    <v-card>
      <v-card-title>
        Categorias
        <v-spacer />
        <v-btn color="#FF562B" @click="abrirDialog()" dark
          ><i class="mdi mdi-plus"></i>Nova Categoria</v-btn
        >
      </v-card-title>
      <v-data-table :headers="headers" :items="categorias" item-value="id" class="elevation-1">
        <template v-slot:[`item.acoes`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon small color="default" v-bind="attrs" v-on="on" @click="abrirDialog(item)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Editar</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                small
                color="red"
                v-bind="attrs"
                v-on="on"
                @click="solicitarExclusao(item)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>Excluir</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>

    <!-- Diálogo para criar/editar -->
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="text-h6">{{ categoriaSelecionada.id ? 'Editar' : 'Nova' }} Categoria</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form">
            <v-text-field
              v-model="categoriaSelecionada.name"
              label="Nome da Categoria"
              :rules="[v => !!v || 'Campo obrigatório']"
              required
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="fecharDialog">Cancelar</v-btn>
          <v-btn
            color="#FF562B"
            @click="
              {
                {
                  categoriaSelecionada.id
                    ? editarCategoria(categoriaSelecionada.id)
                    : salvarCategoria();
                }
              }
            "
            dark
            ><i class="mdi mdi-content-save"></i> Salvar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ConfirmDialog
      :value="confirmDialogVisible"
      @input="confirmDialogVisible = $event"
      :message="`Tem certeza que deseja excluir o item '${itemSelecionado?.name}'?`"
      @confirm="confirmarExclusao"
    />
    <AlertaModal v-model="alerta" :mensagem="mensagem" :titulo="'Atenção!'" />
  </div>
</template>

<script>
import {
  getCategories,
  storeCategory,
  deleteCategory,
  updateCategory,
} from '../../services/estoque/categoria-servico';
import ConfirmDialog from '../Modais/ConfirmDialog.vue';
import AlertaModal from '../Modais/AlertaModal.vue';
export default {
  components: { ConfirmDialog, AlertaModal },
  data() {
    return {
      confirmDialogVisible: false,
      itemSelecionado: null,
      dialog: false,
      categorias: [],
      categoriaSelecionada: {},
      alerta: false,
      mensagem: '',
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Nome', value: 'name' },
        { text: 'Ações', value: 'acoes', sortable: false },
      ],
    };
  },
  mounted() {
    this.carregarCategorias();
  },
  methods: {
    async carregarCategorias() {
      this.categorias = await getCategories();
    },
    abrirDialog(categoria = {}) {
      this.categoriaSelecionada = { ...categoria };
      this.dialog = true;
    },
    fecharDialog() {
      this.dialog = false;
      this.categoriaSelecionada = {};
    },
    async salvarCategoria() {
      const form = this.$refs.form;
      if (form && form.validate()) {
        await storeCategory(this.categoriaSelecionada);
        this.fecharDialog();
        this.carregarCategorias();
      }
    },
    async editarCategoria(categoriaSelecionadaId) {
      const form = this.$refs.form;
      if (form && form.validate()) {
        await updateCategory(categoriaSelecionadaId, this.categoriaSelecionada);
        this.fecharDialog();
        this.carregarCategorias();
      }
    },

    solicitarExclusao(item) {
      this.itemSelecionado = item;
      this.confirmDialogVisible = true;
    },

    async confirmarExclusao() {
      try {
        await deleteCategory(this.itemSelecionado.id);
        this.carregarCategorias();
        this.itemSelecionado = null;
      } catch (e) {
        console.error('Erro ao excluir:', e);
        this.alerta = true;
        this.mensagem =
          'Existem itenas vinculadas a essa categoria. Dê baixa primeiro nos saldos dos itens.';
      }
    },
  },
};
</script>
